export const tooloptions = [
	  { value: 'Axe', label: 'Axe', parm: 'tools' },
	  { value: 'Bindle Stick', label: 'Bindle Stick', parm: 'tools' },
	  { value: 'Black Sword', label: 'Black Sword', parm: 'tools' },
	  { value: 'Blade', label: 'Blade', parm: 'tools' },
	  { value: 'Claws', label: 'Claws', parm: 'tools' },
	  { value: 'Club', label: 'Club', parm: 'tools' },
	  { value: 'Decker Gun', label: 'Decker Gun', parm: 'tools' },
	  { value: 'Gold Plated', label: 'Gold Plated', parm: 'tools' },
	  { value: 'Green Gem', label: 'Green Gem', parm: 'tools' },
	  { value: 'Guitar', label: 'Guitar', parm: 'tools' },
	  { value: 'Hammer', label: 'Hammer', parm: 'tools' },
	  { value: 'Music', label: 'Music', parm: 'tools' },
	  { value: 'Pipe', label: 'Pipe', parm: 'tools' },
	  { value: 'Pliers', label: 'Pliers', parm: 'tools' },
	  { value: 'Scoped Gun', label: 'Scoped Gun', parm: 'tools' },
	  { value: 'Shocker', label: 'Shocker', parm: 'tools' },
	  { value: 'Skull', label: 'Skull', parm: 'tools' },
	  { value: 'Skull Staff', label: 'Skull Staff', parm: 'tools' },
	  { value: 'Spiked', label: 'Spiked', parm: 'tools' },
	  { value: 'Squirt Gun', label: 'Squirt Gun', parm: 'tools' },
	  { value: 'Teddy Bear', label: 'Teddy Bear', parm: 'tools' },
	  { value: 'Tribe Item', label: 'Tribe Item', parm: 'tools' },
	  { value: 'Wine', label: 'Wine', parm: 'tools' },
	  { value: 'Wrench', label: 'Wrench', parm: 'tools' },
];